import { AppInfo, BuildTargetId, HashInfo } from "../types";

class AppService {
    static async getSuparAppInfo({ buildTargetId }: { buildTargetId: BuildTargetId }): Promise<AppInfo | undefined> {
        const url = `https://api-build.cdmvision.dev/api/v2/apps/projects/supar/buildtargets/${buildTargetId}/version`;
        const response = await fetch(url, { mode: "cors" });
        const appInfo: AppInfo = await response.json();

        return appInfo;
    }

    static async getHashInfoList({ buildTargetId }: { buildTargetId: BuildTargetId }): Promise<HashInfo[]> {
        const url = `https://api-build.cdmvision.dev/api/v2/tasks/projects/supar/buildtargets/${buildTargetId}/versions/hash`;
        const response = await fetch(url, { mode: "cors" });
        const data = await response.json();

        return data;
    }
}

export default AppService;
